/**
 * EmailValidationError Component
 * Displays error when email validation fails
 */

import React from 'react';
import { User } from 'lucide-react';
import { Card, CardContent } from '../../card';
import { Button } from '../../button';
import { useRouter, usePathname } from 'next/navigation';

interface EmailValidationErrorProps {
  email: string;
}

export function EmailValidationError({ email }: EmailValidationErrorProps) {
  const router = useRouter();
  const pathname = usePathname();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <Card className="shadow-lg">
          <CardContent className="px-6 pb-6 pt-8">
            <div className="text-center py-12">
              <div className="w-16 h-16 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center">
                <User className="w-8 h-8 text-red-600" />
              </div>
              <h2 className="text-2xl font-bold text-card-foreground mb-4">User Not Found</h2>
              <p className="text-gray-600 mb-2">
                The email address <strong className="font-semibold">{email}</strong> is not available for booking.
              </p>
              <p className="text-sm text-gray-500 mb-6">
                Please check the URL or contact support if you believe this is an error.
              </p>
              <Button
                onClick={() => {
                  router.replace(pathname || '');
                }}
                variant="outline"
              >
                Start Over
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
